exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header-for-contact {\n  justify-content: space-between;\n  padding: 13px 10px;\n  background-color: rgba(226, 230, 235, 0.84);\n}\n.mobile-department-title {\n  font-weight: 600;\n  font-size: 1.15rem;\n  color: rgba(6, 38, 62, 0.84);\n}\n", ""]);

// exports
